<template>
  <div class="container">
    <form @submit.prevent="submitEditMailaddress" novalidate>
      <breadcrumb-group :items="breadcrumbItems"/>

      <heading-one>メールアドレス・お知らせ通知設定の変更</heading-one>

      <errors-alert :errors="errors" column-only="true" :items="inputItemsMb"></errors-alert>

      <wizard-group class="_mb-md-60 _mb-sm-20">
        <main-wizard :active-index="0" type="useremail"></main-wizard>
      </wizard-group>

      <p>変更内容をご入力のうえ、「確認画面へ」を押してください。</p>

      <section>
        <table-group>
          <table-box class="_mb-10">
            <table-body>
              <!-- ローカルログインのメアドは変更不可 -->
              <template v-if="!localUser">
                <template v-if="showDefaultMail">
                  <table-row>
                    <table-header rowspan="3">
                      メールアドレス※
                    </table-header>
                    <table-data>
                      {{displayEzMail}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-data>
                      {{displayMail1}}
                    </table-data>
                  </table-row>
                  <table-row>
                    <table-data>
                      {{displayMail2}}
                    </table-data>
                  </table-row>
                </template>
              </template>
              <!-- その他のアドレス -->
              <table-row>
                <table-header>
                  メールアドレス
                </table-header>
                <table-data>
                  <div class="_mb-15">{{displayLoanMailDisp}}</div>
                  <btn-help @click.prevent="showEditMailAddress">変更する</btn-help>
                </table-data>
              </table-row>
              <table-row v-show="editMailAddress">
                <table-header>
                  変更後のメールアドレス<small class="moji">【半角英数】</small>
                </table-header>
                <table-data :hasError="errors['edit_mail']">
                  <input-group :errors="errors" :propNames="['edit_mail']">
                    <input-item class="-lg" v-model="userData.edit_mail" id="edit_mail" :maxlength="50"></input-item>
                    <input-label>入力例:****@au.com</input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row v-show="editMailAddress">
                <table-header>
                  変更後のメールアドレス<small>（確認用）<small class="moji">【半角英数】</small></small>
                </table-header>
                <table-data :hasError="errors['edit_mail_confirmation']">
                  <input-group :errors="errors" :propNames="['edit_mail_confirmation']">
                    <input-item class="-lg" v-model="userData.edit_mail_confirmation" id="edit_mail_confirmation" :maxlength="50"></input-item>
                    <input-label>入力例:****@au.com</input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header>
                  お知らせ通知設定
                  <btn-tooltip slot="tooltip" target="noticeTooltip" class="-question"></btn-tooltip>
                  <tooltips-item slot="tooltip" target="noticeTooltip" placement="righttop" clazz="question-box">
                    ・ご案内を希望される内容にチェックをしてください。<br />
                    ・ご不要の場合はチェックを外してください。なお、大切なご案内に関するメールは、変更ができません。
                  </tooltips-item>
                </table-header>
                <table-data>
                  <p>現在ご登録いただいているお知らせ通知設定を表示しています。</p>
                  <input-group class="row">
                    <div class="col-12 col-md-6 _mb-sm-15 _mb-md-15">
                      <input-check id="cpn_ukt_flg" value="1" v-model="userData.cpn_ukt_flg">キャンペーン情報</input-check>
                    </div>
                    <div class="col-12 col-md-6 _mb-sm-15 _mb-md-15">
                      <input-check id="kri_tti_ukt_flg" value="1" v-model="userData.kri_tti_ukt_flg">お借入れ時</input-check>
                    </div>
                    <div class="col-12 col-md-6 _mb-sm-15">
                      <input-check id="hen_soku_ukt_flg" value="1" v-model="userData.hen_soku_ukt_flg">ご返済時</input-check>
                    </div>
                    <div class="col-12 col-md-6">
                      <input-check id="mns_stm_ukt_flg" value="1" v-model="userData.mns_stm_ukt_flg">マンスリーステートメント発行</input-check>
                    </div>
                  </input-group>
                </table-data>
              </table-row>
            </table-body>
          </table-box>
        </table-group>
        <div class="_mb-md-60 _mb-sm-30"><small>※au IDにご登録の連絡先メールアドレスを表示しております。変更をご希望の場合は、<a href="https://id.auone.jp/" class="btn-text textlink" target="_blank">au IDサイト</a>にて連絡先メールアドレスをご登録ください。</small></div>

        <btngroup-double class="-margin-lg">
          <btn-main slot="main" class="-main" @click.prevent="submitEditMailaddress">
            確認画面へ
          </btn-main>
          <btn-back slot="back" class="-back -sm" routerName="mb023">
            戻る
          </btn-back>
        </btngroup-double>
      </section>

    </form>

  </div>
</template>

<script>
import { initCredentials } from '../utils/Auth'
import { getUserDataForMemberLambdaInvoke, editMailaddressLambdaInvoke } from '../utils/LambdaHelper'
import { inputItemsMb } from '../constants/constant'
import userData from '../components/mixin/UserData'

import ErrorsAlert from '../components/alert/ErrorsAlert'
import HeadingOne from '../components/heading/HeadingOne'
import WizardGroup from '../components/wizard/WizardGroup'
import MainWizard from '../components/wizard/MainWizard'
import TableGroup from '../components/tables/TableGroup'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import BtnTooltip from '../components/button/BtnTooltip'
import TooltipsItem from '../components/tooltip/TooltipsItem'
import TableData from '../components/tables/TableData'
import BtnHelp from '../components/button/BtnHelp'
import InputGroup from '../components/input/InputGroup'
import InputItem from '../components/input/InputItem'
import InputLabel from '../components/input/InputLabel'
import InputCheck from '../components/input/InputCheck'
import BtngroupDouble from '../components/button/BtngroupDouble'
import BtnMain from '../components/button/BtnMain'
import BtnBack from '../components/button/BtnBack'
export default {
  name: 'Mb-026',
  metaInfo: {
    title: 'メールアドレス・お知らせ通知設定の変更｜お客さま情報の確認・変更',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報'}
    ]
  },
  mixins: [userData],
  components: {
    BtnBack,
    BtnMain,
    BtngroupDouble,
    InputCheck,
    InputLabel,
    InputItem,
    InputGroup,
    BtnHelp,
    TableData,
    TooltipsItem,
    BtnTooltip,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    MainWizard,
    WizardGroup,
    HeadingOne,
    ErrorsAlert
  },
  props: {
    editMailAddress: false
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'お客さま情報の確認・変更',
        routerName: 'mb023'
      },
      {
        text: 'メールアドレス・お知らせ通知設定の変更',
        active: true
      }
      ],
      errors: {},
      showOtherMailAddress: false,
      profile: {
        mail_address: '',
        mail_notice: '',
        // 要確認項目
        other_mail_address: '',
        other_mail_address_confirmation: ''
      },
      isDisabled: false,
      orgLoanMail: '',
      userData: {
        id_type: '',
        ez_mail: '',
        mail_1: '',
        mail_2: '',
        edit_mail: '',
        edit_mail_confirmation: '',
        loan_mail: '',
        loan_mail_confirmation: '',
        loan_mail_disp: '',
        cpn_ukt_flg: '0',
        hen_soku_ukt_flg: '0',
        kri_tti_ukt_flg: '0',
        mns_stm_ukt_flg: '0'
      },
      inputItemsMb: inputItemsMb
    }
  },
  mounted () {
    try {
      getUserDataForMemberLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
        this.orgLoanMail = this.userData.loan_mail
        if (this.userData.loan_mail !== this.userData.loan_mail_confirmation) {
          this.userData.edit_mail = ''
          this.userData.edit_mail_confirmation = ''
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  },
  methods: {
    submitEditMailaddress: function (event) {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        this.setCheckBoxVal()
        initCredentials().then(res => {
          editMailaddressLambdaInvoke(this.userData).then(res => {
            this.errors = res.errors || {}
            if (Object.keys(this.errors).length > 0) {
              this.scrollTop()
              this.isDisabled = false
            } else {
              this.$router.push({name: 'mb029'})
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setCheckBoxVal () {
      if (!this.userData.cpn_ukt_flg) this.userData.cpn_ukt_flg = '0'
      if (!this.userData.hen_soku_ukt_flg) this.userData.hen_soku_ukt_flg = '0'
      if (!this.userData.kri_tti_ukt_flg) this.userData.kri_tti_ukt_flg = '0'
      if (!this.userData.mns_stm_ukt_flg) this.userData.mns_stm_ukt_flg = '0'
    },
    showEditMailAddress: function () {
      this.editMailAddress = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
  .-underline {
    text-decoration: underline;
  }
  .btn-text {
    &:hover {
      text-decoration: underline;
      color: $orange !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Mb026.vue